import type { TFunction } from 'i18next'
import IconCheck from '@/shared/icons/NewDesign/IconCheck'
import type { ProgressStep } from './saleProgress'
import { StepItem, StepLabel, StepNode, StepTime } from './styled-components'

interface SaleStatusStepProps {
  step: ProgressStep
  first: boolean
  t: TFunction
}

const SaleStatusStep = ({ step, first, t }: SaleStatusStepProps) => (
  <StepItem $state={step.state} $first={first}>
    <StepNode $state={step.state} aria-hidden='true'>
      {step.state === 'done' && <IconCheck size={14} />}
    </StepNode>
    <StepLabel $state={step.state}>{t(step.label)}</StepLabel>
    <StepTime aria-hidden='true'>{step.time ?? ''}</StepTime>
  </StepItem>
)

export default SaleStatusStep
